import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const forWho = ['Profesionales y mandos medios que sienten que su trabajo les está robando la salud.', 'Emprendedores que no saben cómo apagar la cabeza al cerrar la laptop.', 'Madres y padres que llegan a casa sin energía para jugar con sus hijos.', 'Personas que sufren de "ansiedad dominical" y pavor al lunes.'];
const notForWho = ['Personas que buscan una solución mágica sin cambiar ni un solo hábito de sueño.', 'Quienes prefieren seguir quejándose de su jefe en lugar de poner límites biológicos.', 'Estudiantes que buscan consejos de productividad para estudiar 20 horas seguidas.'];
export function WhoIsForSection() {
  return <section className="py-24 px-6 bg-charcoal-800 border-y border-charcoal-700" data-id="element-210">
      <div className="max-w-6xl mx-auto" data-id="element-211">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8" data-id="element-212">
          {/* Para quién ES */}
          <FadeIn direction="right" data-id="element-213">
            <div className="bg-charcoal-900/50 p-8 sm:p-10 rounded-sm border border-mutedteal/20 h-full" data-id="element-214">
              <h3 className="font-heading text-3xl text-offwhite mb-8 flex items-center gap-3" data-id="element-215">
                <span className="text-mutedteal" data-id="element-216">Para quién ES</span>
              </h3>
              <ul className="space-y-6" data-id="element-217">
                {forWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-218">
                    <CheckCircleIcon className="w-6 h-6 text-mutedteal shrink-0 mt-0.5" data-id="element-219" />
                    <span className="text-offwhite/80 text-lg font-light leading-relaxed" data-id="element-220">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO ES */}
          <FadeIn direction="left" delay={0.2} data-id="element-221">
            <div className="bg-charcoal-900/50 p-8 sm:p-10 rounded-sm border border-charcoal-700 h-full opacity-80" data-id="element-222">
              <h3 className="font-heading text-3xl text-offwhite/60 mb-8 flex items-center gap-3" data-id="element-223">
                <span data-id="element-224">Para quién NO ES</span>
              </h3>
              <ul className="space-y-6" data-id="element-225">
                {notForWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-226">
                    <XIcon className="w-6 h-6 text-charcoal-600 shrink-0 mt-0.5" data-id="element-227" />
                    <span className="text-offwhite/50 text-lg font-light leading-relaxed" data-id="element-228">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}